import React, { useEffect, useRef, useContext } from "react";
import { useState } from "react";
import "./ViewMore.css";
import { BsArrowLeft } from "react-icons/bs";
import { IoSearchOutline } from "react-icons/io5";
import { CiFilter } from "react-icons/ci";
import { BiSortAlt2 } from "react-icons/bi";
import Select from "react-select";
import { IoAdd } from "react-icons/io5";
import { Pagination } from "antd";

import viewProfile from "../../assets/images/viewProfile.png";
import { IoShareSocialOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { data, Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// import Modal from "@mui/material/Modal";
// import Button from "@mui/material/Button";
import { IoIosSearch } from "react-icons/io";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { axiosInstance } from "../../axiosInstance";
import { FaRegEdit } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import { FaShare } from "react-icons/fa";
import { TbCircleFilled } from "react-icons/tb";
import { Typography } from "@mui/material";
import axios from "axios";
import "./code.css";
import { axiosInstance_user } from "../../axiosInstance_user";

const options = [
  { value: "Recently Added", label: "Recently Added" },
  { value: "A to Z", label: "A to Z" },
  { value: "Z to A", label: "Z to A" },
  { value: "Popularity", label: "Popularity" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: 400,
    md: 500,
  },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  py: 4,
  px: 2,
};

export function ViewMore() {
  // const matchmaker_name = localStorage.getItem("matchmaker_name");
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [profilesPerPage] = useState(8); // Products per page
  const [currentProfiles, setCurrentProfiles] = useState([]); // Products to display on the current page

  const [selectedCaste, setSelectedCaste] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedReligion, setSelectedReligion] = useState("");
  const [selectedAge, setSelectedAge] = useState();
  const [agentName, setAgentName] = useState();
  const [filterDot, setFilterDot] = useState(false);
  const [state, setState] = useState([]);
  const [matchmakerPlan, setmatchmakerPlan] = useState();
  const [religion, setReligion] = useState([]);
  const religionId = localStorage.getItem("selectedReligionId");
  const [caste, setCaste] = useState([]);
  const [searchCaste, setSearchCaste] = useState("");
  const [onboardAgentName, setOnboardAgentName] = useState();
  const public_token = localStorage.getItem("public_token");
  const filteredCaste = localStorage.getItem("selectedCaste") || "";
  const filteredLocation = localStorage.getItem("selectedLocation") || "";
  const filteredReligion = localStorage.getItem("selectedReligion") || "";
  const filteredAge = localStorage.getItem("selectedAge") || "";

  //active modal filter
  const [selectedTab, setSelectedTab] = useState("Religion");

  // Delete Modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
  };
  const handleDeleteShow = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // filter modal state
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  //card Age calculation function
  // const Age = (dob) => {
  //   const birthDate = new Date(dob);
  //   const today = new Date();
  //   let age = today.getFullYear() - birthDate.getFullYear();
  //   const m = today.getMonth() - birthDate.getMonth();

  //   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
  //     age--;
  //   }

  //   return age;
  // };

  async function LoadMatchmaker() {
    try {
      const response = await axiosInstance.get("/profile");
      const matchmakerData = response.data.data;
      setmatchmakerPlan(matchmakerData.plan);

      setAgentName(matchmakerData.first_name);
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }
  useEffect(() => {
    LoadMatchmaker();
  }, []);
  // search api

  const [searchInput, setsearchInput] = useState("");
  const typingTimeoutRef = useRef(null);

  // const handleInputChange = (e) => {
  //   const value = e.target.value;
  //   setsearchInput(value);

  //   if (typingTimeoutRef.current) {
  //     clearTimeout(typingTimeoutRef.current);
  //   }

  //   typingTimeoutRef.current = setTimeout(() => {
  //     handleSearch(value);
  //   }, 500); // 500ms debounce delay
  // };

  // async function handleSearch(Name) {
  //   try {
  //     console.log("Name seach click", Name);
  //     const response = await axiosInstance.get(
  //       `/biodata-search?search=${Name}`
  //     );
  //     const searchdata = response.data;
  //     // console.log(userdata);
  //     console.log("searchdata", searchdata.data);
  //     setProfiles(searchdata.data);
  //   } catch (error) {
  //     console.error("Error fetching user details", error);
  //   }
  // }

  const handleInputChange = (e) => {
    const value = e.target.value;
    setsearchInput(value);

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    typingTimeoutRef.current = setTimeout(() => {
      if (value.trim() !== "") {
        handleSearch(value.trim());
      } else {
        LoadProfiles(); // load all if input cleared
      }
    }, 500); // debounce
  };

  // Search API

  async function LoadProfiles() {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/biodata");
      const userdata = response.data;
      console.log("data all list", userdata.data);
      setProfiles(userdata.data);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user details", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const startIndex = (currentPage - 1) * profilesPerPage;
    const endIndex = startIndex + profilesPerPage;
    setCurrentProfiles(profiles.slice(startIndex, endIndex));
  }, [profiles, currentPage]);

  // sort api
  const [sortoption, setSortOption] = useState();
  async function handleSort(option) {
    setLoading(true);
    //direct get option onChange by using react-select
    setSortOption(option);
    console.log("option", option);
    try {
      // option returns both option and label so use option.value
      const response = await axiosInstance.get(
        `/biodata-sort?sort_by=${option.value}`
      );
      const sortdata = response.data;
      // console.log(userdata);
      console.log("sortdata", sortdata.data);
      setProfiles(sortdata.data);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user details", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    LoadProfiles();
  }, []);

  async function deleteProfile(id) {
    try {
      const response = await axiosInstance.delete(`/biodata/${id}`);
      if (response.data.status === true) {
        toast.success(response.data.message || "Deleted Successfully!");
        LoadProfiles();
      } else {
        toast.error("Something went wrong, please try again!");
      }
    } catch (error) {
      console.error("Error deleting profile", error);
      toast.error("Error deleting profile.");
    }
  }
  function handleReset() {
    localStorage.removeItem("selectedCaste");
    localStorage.removeItem("selectedLocation");
    localStorage.removeItem("selectedReligion");
    localStorage.removeItem("selectedAge");
    localStorage.removeItem("selectedReligionId");
    LoadProfiles();
    handleClose();
    setFilterDot(false);
  }
  function handleBtnClose() {
    handleClose();
    localStorage.removeItem("selectedCaste");
    localStorage.removeItem("selectedLocation");
    localStorage.removeItem("selectedReligion");
  }
  async function handleApplyFilter() {
    try {
      const caste = localStorage.getItem("selectedCaste") || "";
      const location = localStorage.getItem("selectedLocation") || "";
      const religion = localStorage.getItem("selectedReligion") || "";
      const age = localStorage.getItem("selectedAge") || "";
      const response = await axiosInstance.get(
        `/biodata-filter?caste=${caste}&religion=${religion}&location=${location}&age=${age}`
      );
      const filterdata = response.data;

      console.log("filterdata", filterdata.data);
      setProfiles(filterdata.data);
      handleClose();
      setFilterDot(true);
    } catch (error) {
      console.error("Error in filter", error);
      toast.error("Error in filter");
    }
  }

  async function handlePublicProfile() {
    const public_token = localStorage.getItem("public_token");
    try {
      const response = await axiosInstance.get(
        `/share-biodata-list/${public_token}`
      );
      setOnboardAgentName(response.data.data.first_name);
    } catch (error) {
      console.log("Error while fetching profiles", error);
    }
  }

  useEffect(() => {
    handlePublicProfile();
  }, []);

  async function LoadCaste(religionId) {
    try {
      const response = await axiosInstance_user.get(
        `/dropdown/caste/${religionId}`
      );
      const data = response.data;
      console.log("caste", data);
      setCaste(data);
    } catch (error) {
      console.error("Error loading caste list", error);
    }
  }

  // useEffect(() => {
  //   LoadCaste(religionId);
  // }, [religionId]);

  useEffect(() => {
    if (religionId) {
      console.log("Fetching caste for religionId:", religionId);
      LoadCaste(religionId);
    }
  }, [religionId]);

  //modal caste search

  // async function handleSearch(Name) {
  //   try {
  //     console.log("Name seach click", Name);
  //     const response = await axiosInstance.get(
  //       `/biodata-search?search=${Name}`
  //     );
  //     const searchdata = response.data;
  //     // console.log(userdata);
  //     console.log("searchdata", searchdata.data);
  //     setSearchCaste(searchdata.data);
  //   } catch (error) {
  //     console.error("Error fetching user details", error);
  //   }
  // }

  async function handleSearch(name) {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/biodata-search?search=${name}`
      );
      const searchData = response.data?.data || [];
      setProfiles(searchData);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error searching profiles", error);
    } finally {
      setLoading(false);
    }
  }
  const [modalcontent, setModalcontent] = useState(handleCasteState());
  function handleCasteState() {
    return (
      <div>
        {/* <div className="filter-search">
          <IoIosSearch className="filter-searchIcon" />
          <input type="text" placeholder="Search"
                  />
        </div> */}
        {religionId ? (
          <div className="casteList">
            {caste.map((c) => (
              <div key={c.id}>
                <input
                  type="radio"
                  name="caste"
                  value={c.name}
                  onChange={() => {
                    setSelectedCaste(c.name);
                    localStorage.setItem("selectedCaste", c.name);
                  }}
                />
                <span className="ms-2">{c.name}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center pt-4">First Select Religion</div>
        )}
      </div>
    );
  }

  function handlemodalCaste() {
    setModalcontent(handleCasteState());
    setSelectedTab("Caste");
  }
  async function LoadState() {
    try {
      const response = await axiosInstance_user.get(
        "/dropdown/states"
      );
      const data = response.data;
      console.log("State", response.data);
      setState(data);
    } catch (error) {
      toast.error("Error white fetching", error);
    }
  }
  useEffect(() => {
    LoadState();
  }, []);

  function handlemodalLocation() {
    setSelectedTab("Location");
    setModalcontent(
      <div>
        {/* <div className="filter-search">
          <IoIosSearch className="filter-searchIcon" />
          <input type="text" placeholder="Enter Location" />
        </div> */}

        <div className="casteList">
          {state.map((loc) => (
            <div key={loc.id}>
              <input
                type="radio"
                name="location"
                value={loc.name}
                // checked={selectedLocation === loc.name}
                onChange={() => {
                  setSelectedLocation(loc.name); // Set name in state
                  localStorage.setItem("selectedLocation", loc.name); // Store name as string
                }}
              />
              <span className="ms-2">{loc.name}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  async function LoadReligion() {
    try {
      const response = await axiosInstance_user.get(
        "/dropdown/choices"
      );

      if (response.status === 200 && response.data) {
        console.log("religion", response.data.religion);
        setReligion(response.data.religion);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }
  useEffect(() => {
    LoadReligion();
  }, []);

  useEffect(() => {
    if (show) {
      handlemodalReligion();
    }
  }, [show]);

  function handlemodalReligion() {
    setSelectedTab("Religion");
    setModalcontent(
      <div>
        <div className="casteList">
          {religion.map((rel) => (
            <div key={rel.id}>
              <input
                type="radio"
                name="religion"
                // checked={selectedReligion === rel}
                onChange={() => {
                  setSelectedReligion(rel.name);
                  localStorage.setItem("selectedReligion", rel.name);
                  localStorage.setItem("selectedReligionId", rel.id);
                }}
              />
              <span className="ms-2">{rel.name}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // function handlemodalAge() {
  //   setSelectedTab("Age");
  //   setModalcontent(
  //     <div>
  //       {/* <Box  sx={{ width: 200 }}> */}
  //       <Box
  //         sx={{
  //           width: {
  //             xs: "90%", // for extra-small screens
  //             sm: 400, // for small screens and up
  //             md: 280, // for medium screens and up
  //           },
  //           paddingTop: "15px",
  //         }}
  //       >
  //         <Slider
  //           size="small"
  //           value={selectedAge}
  //           onChange={(e, newValue) => {
  //             setSelectedAge(newValue);
  //             localStorage.setItem("selectedAge", newValue);
  //           }}
  //           aria-label="Small"
  //           valueLabelDisplay="auto"
  //           sx={{
  //             color: "#F24464", // Changes the active track and thumb color
  //           }}
  //         />
  //       </Box>
  //     </div>
  //   );
  // }

  function handlemodalAge() {
    setSelectedTab("Age");
    setModalcontent(
      <div>
        <Box
          sx={{
            width: {
              xs: "90%",
              sm: 400,
              md: 280,
            },
            paddingTop: "15px",
          }}
        >
          <select
            value={selectedAge}
            onChange={(e) => {
              const selected = parseInt(e.target.value);
              setSelectedAge(selected);
              localStorage.setItem("selectedAge", selected);
            }}
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          >
            <option value="">Select Age</option>
            {[20, 25, 30, 35, 40, 45, 50, 55].map((age) => (
              <option key={age} value={age}>
                {age}
              </option>
            ))}
          </select>
        </Box>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />
      <div className="viewmoreBg ">
        <div className="container ">
          <div className="menu-items">
            <Link to="/home" style={{ color: "#716466", marginRight: "10px" }}>
              {" "}
              <span>
                <BsArrowLeft />
              </span>
            </Link>
            <span>{translations[language].dashboard}</span>
            <span> {translations[language].profile}</span>
          </div>
          <div className="profileTitle">
            {translations[language].profile_upload} {agentName}
          </div>
          <div className="search-main-container">
            <div className="search-container">
              <span>
                <input
                  placeholder="Search"
                  onChange={handleInputChange}
                  value={searchInput}
                />
              </span>
              {/* filter */}
              <div className="filter-container">
                <Button onClick={handleShow}>
                  <CiFilter /> Filter{" "}
                  <span
                    style={{ display: filterDot ? "inline" : "none" }}
                    className="filterDot"
                  >
                    <TbCircleFilled />
                  </span>
                </Button>
              </div>
            </div>
            <div className="search-subcontainer">
              {/* Sort */}
              <div>
                <span>
                  <Select
                    placeholder="Sort"
                    options={options}
                    isSearchable={false}
                    value={sortoption}
                    onChange={handleSort}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        width: "100%",
                        minHeight: "39px",
                        borderColor: "#E4E4E4",
                        borderColor: state.isFocused
                          ? "#E4E4E4"
                          : base.borderColor,
                        boxShadow: state.isFocused ? "#E4E4E4" : base.boxShadow,
                        "&:hover": {
                          borderColor: "#E4E4E4",
                        },
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused
                          ? "#FEECF0"
                          : state.isSelected
                          ? "transparent"
                          : "transparent",
                        color: "#707070",
                        cursor: "pointer",
                        ":active": {
                          backgroundColor: "#FEECF0", // fixes the blue flicker when selecting
                        },
                      }),

                      menu: (base) => ({
                        ...base,
                        width: "180px",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }),
                    }}
                  />
                </span>
              </div>
              {/* <div className="btnsharePublic">
              <Link to="/share-public-profile">
                <button>
                  <FaShare className="me-1 fs-5" />
                  <span className="btnaddText">Share Public Page</span>
                </button>
              </Link>
            </div> */}
              {matchmakerPlan === "Recommended" ||
              matchmakerPlan === "Premium" ? (
                <div className="btnsharePublicHome">
                  <a
                    href={`/share-public-profile/${public_token}/${onboardAgentName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button>
                      <FaShare className="me-1 fs-5" />
                      <span className="btnaddText">Share Public Page</span>
                    </button>
                  </a>
                </div>
              ) : (
                <div className="btnsharePublicHome d-none"></div>
              )}

              <div className="btnaddProfile">
                <Link to="/add-profile">
                  <button>
                    <IoAdd className="me-1 fs-5" />
                    <span className="btnaddText">
                      {translations[language].btnAdd}
                    </span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
          {/* filtered data   */}
          {(filteredCaste ||
            filteredReligion ||
            filteredLocation ||
            filteredAge) && (
            <div className="mb-3">
              <span className="selectedFilter"> Showing results of :</span>
              <span className="filteredData">
                {" "}
                {[
                  filteredCaste,
                  filteredLocation,
                  filteredReligion,
                  filteredAge,
                ]
                  .filter(Boolean) // removes null, undefined, empty string
                  .join(", ")}
              </span>
            </div>
          )}

          <div>
            {loading ? (
              <div className="loading-message">Loading profiles...</div>
            ) : profiles.length === 0 && searchInput.trim() !== "" ? (
              <div className="no-data-message">No matching profiles found</div>
            ) : currentProfiles.length > 0 ? (
              <div className="viewcards-section">
                {currentProfiles.map((profiles) => (
                  <div className="viewcard" key={profiles.id}>
                    <div className="viewcard-grid">
                      <div className="viewcardImg">
                        {/* <img src={profiles.images[0].image} alt="profileImg" /> */}
                        <img src={profiles.profile} alt="profileImg" />
                      </div>
                      <div className="viewcard-content">
                        <div>
                          <div>
                            <span>Name</span>
                          </div>
                          <div>
                            <span>Education</span>
                          </div>
                          <div>
                            <span>Occupation</span>
                          </div>
                          <div>
                            <span>Age</span>
                          </div>
                          <div>
                            <span>Religion</span>
                          </div>
                          <div>
                            <span>Caste</span>
                          </div>
                          <div>
                            <span>Marital Status</span>
                          </div>
                          <div>
                            <span>Location</span>
                          </div>
                        </div>
                        <div>
                          <div>
                            <span>{profiles.name || "---"}</span>
                          </div>
                          <div>
                            <span>{profiles.education || "---"}</span>
                          </div>
                          <div>
                            <span>{profiles.employed_in || "---"}</span>
                          </div>
                          {/* <div>{Age(profiles.dob) || "---"} years</div> */}
                          <div>{profiles.age || "---"} years</div>
                          <div>{profiles.religion || "---"}</div>
                          <div>{profiles.caste || "---"}</div>
                          <div>{profiles.marital_status || "---"}</div>
                          <div>{profiles.state || "---"}</div>
                        </div>
                      </div>
                    </div>
                    <div className="viewcard-icons">
                      <div>
                        <span
                          className="me-3"
                          style={{ color: "#BDB7B8", fontSize: "20px" }}
                          onClick={() =>
                            navigate(`/share-profile/${profiles.encrypted_id}`)
                          }
                        >
                          <IoShareSocialOutline />
                        </span>
                        <span
                          className="me-3"
                          style={{
                            color: "#BDB7B8",
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          // onClick={() => {
                          //   const flag = window.confirm(
                          //     "Are you sure you want to delete this profile?"
                          //   );
                          //   if (flag) {
                          //     deleteProfile(profiles.id);
                          //   }
                          // }}
                        >
                          <RiDeleteBin6Line
                            onClick={() => handleDeleteShow(profiles.id)}
                          />
                        </span>

                        <Link
                          className="vieweditBtn"
                          to={`/edit-profile/${profiles.id}`}
                        >
                          <span style={{ color: "#BDB7B8", fontSize: "20px" }}>
                            <FaRegEdit />
                          </span>
                        </Link>
                      </div>
                      <div>
                        <span
                          className="me-3 vieweditBtn"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate("/view-profile", {
                              state: { Details: profiles },
                            });
                          }}
                        >
                          View Profile
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-data-message">No Profiles found...</div>
            )}
          </div>
          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteModal} onHide={handleDeleteClose} centered>
            {/* <Modal.Header closeButton style={{ borderBottom: "none" }}>
            <Modal.Title>{translations[language].confirmDelete || "Confirm Delete"}</Modal.Title>
          </Modal.Header> */}
            <div className="px-4 pt-3">
              <Typography className="delete-title">
                Are you sure you want to delete this profile?
              </Typography>
            </div>
            <Modal.Footer
              style={{ borderTop: "none" }}
              className="deleteFooter"
            >
              <button onClick={handleDeleteClose} className="deletemodalCancel">
                Cancel
              </button>
              <button
                className="deletemodalDelete"
                onClick={() => {
                  if (deleteId) {
                    deleteProfile(deleteId);
                    handleDeleteClose();
                  }
                }}
              >
                Delete
              </button>
            </Modal.Footer>
          </Modal>

          <Pagination
            className="view-pagination"
            current={currentPage}
            pageSize={profilesPerPage}
            total={profiles.length} // Total number of products
            onChange={handlePageChange} // Update displayed products
            showSizeChanger={false} // Disable page size changes
          />

          {/* filter bootstrap-modal content */}

          <Modal
            show={show}
            onHide={handleClose}
            fullscreen="md-down"
            centered
            className="filter-modal"
          >
            <Modal.Body className="filter-body">
              <div className="filter-sidebar">
                <div>
                  {/* <input
                  type="radio"
                  style={{ accentColor: "#F24464" }}
                  name="filterType"
                  onClick={handlemodalReligion}
                />{" "} */}
                  <label
                    onClick={handlemodalReligion}
                    className={selectedTab === "Religion" ? "activeFilter" : ""}
                  >
                    Religion
                  </label>
                </div>
                <div>
                  {/* <input
                  type="radio"
                  style={{ accentColor: "#F24464" }}
                  name="filterType"
                  onClick={handlemodalCaste}
                />{" "} */}
                  <label
                    onClick={handlemodalCaste}
                    className={selectedTab === "Caste" ? "activeFilter" : ""}
                  >
                    Caste
                  </label>
                </div>
                <div>
                  {/* <input
                  type="radio"
                  style={{ accentColor: "#F24464" }}
                  name="filterType"
                  onClick={handlemodalLocation}
                />{" "} */}
                  <label
                    onClick={handlemodalLocation}
                    className={selectedTab === "Location" ? "activeFilter" : ""}
                  >
                    Location
                  </label>
                </div>

                <div>
                  {" "}
                  {/* <input
                  type="radio"
                  style={{ accentColor: "#F24464" }}
                  name="filterType"
                  onClick={handlemodalAge}
                />{" "} */}
                  <label
                    onClick={handlemodalAge}
                    className={selectedTab === "Age" ? "activeFilter" : ""}
                  >
                    Age
                  </label>
                </div>
              </div>
              <div className="filter-content">{modalcontent}</div>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none" }}>
              <Button onClick={handleBtnClose} className="filterBtnClose">
                Close
              </Button>
              <Button onClick={handleReset} className="filterBtnReset">
                Reset
              </Button>
              <Button onClick={handleApplyFilter} className="filterBtnApply">
                Apply Filter
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}
